import {
  Button,
  Card,
  DatePicker,
  MomentObj,
  OptionInterface,
  Select,
  SelectOption,
  Table,
  TableColumns,
  TablePagination,
  TextBox,
} from "@veneer/core";
import "../../assets/css/views/metrics/metricsRanking.css";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useTranslation } from "react-i18next";
import { Moment } from "moment";
import moment from "moment";
import metricSearchSelect from "./MetricsComponent/metricSearchSelect";
import { IOptionsMetricsRanking } from "../../models/input/surveyApi/IOptionsMetrics";
import {
  IFormMetricsRanking,
  IValidationMetricsRanking,
  IValuesMetricsRanking,
} from "../../models/input/surveyApi/IValuesMetrics";
import rankingMetricService from "../../services/surveyApi/rankingMetrics.service";
import { IRankingMetricDtoDto } from "../../models/dto/surveyApi/IMetricsRankingDto";
import UsersManagementService from "../../services/userManagementApi/usersManagement.service";
import { IGetCountriesListDto } from "../../models/dto/userManagementApi/IGetCountriesListDto";
import flagArgentina from "../../assets/img/countries/argentina.png";
import flagBrazil from "../../assets/img/countries/brazil.png";
import flagChile from "../../assets/img/countries/chile.png";
import flagColombia from "../../assets/img/countries/colombia.png";
import flagCostaRica from "../../assets/img/countries/costa-rica.png";
import flagDominicana from "../../assets/img/countries/dominica.png";
import flagEcuador from "../../assets/img/countries/ecuador.png";
import flagElSalvador from "../../assets/img/countries/el-salvador.png";
import flagGuatemala from "../../assets/img/countries/guatemala.png";
import flagHonduras from "../../assets/img/countries/honduras.png";
import flagMexico from "../../assets/img/countries/mexico.png";
import flagNicaragua from "../../assets/img/countries/nicaragua.png";
import flagNotFound from "../../assets/img/countries/not-found.png";
import flagPanama from "../../assets/img/countries/panama.png";
import flagPeru from "../../assets/img/countries/peru.png";
import flagRepublicaDominicana from "../../assets/img/countries/republica-dominicana.png";

export default function MetricsRanking() {
  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const { handleSearch } = metricSearchSelect<IOptionsMetricsRanking>();
  const [isButtonValid, setIsButtonValid] = useState<boolean>(true);

  const initialOptions: IOptionsMetricsRanking = {
    TypeRanking: [],
    Country: [],
    FilteredTypeRanking: [],
    FilteredCountry: [],
  };

  const initialValidation: IValidationMetricsRanking = {
    TypeRanking: true,
    Country: true,
    Date: true,
  };

  const initialForm: IFormMetricsRanking = {
    TypeRanking: "",
    Country: undefined,
    StartDate: "",
    EndDate: "",
  };

  const initialValues: IValuesMetricsRanking = {
    TypeRanking: [],
    Country: [],
    Date: undefined,
    StartDate: null,
    EndDate: null,
    Columns: [],
    TableData: [],
    tableFilteredData: [],
    CurrentPage: 1,
    PageSize: 10,
    Loading: false,
  };

  const [optionSelect, setOptionSelect] = useState<IOptionsMetricsRanking>({
    ...initialOptions,
  });
  const [handleValidate, setHandleValidate] =
    useState<IValidationMetricsRanking>({
      ...initialValidation,
    });
  const [form, setForm] = useState<IFormMetricsRanking>({ ...initialForm });
  const [values, setValues] = useState<IValuesMetricsRanking>({
    ...initialValues,
  });
  const tableDataRef = useRef<IValuesMetricsRanking["TableData"]>([]);

  const flags: { [key: string]: string } = {
    argentina: flagArgentina,
    brazil: flagBrazil,
    chile: flagChile,
    colombia: flagColombia,
    "costa-rica": flagCostaRica,
    dominica: flagDominicana,
    ecuador: flagEcuador,
    "el-salvador": flagElSalvador,
    guatemala: flagGuatemala,
    honduras: flagHonduras,
    mexico: flagMexico,
    nicaragua: flagNicaragua,
    panama: flagPanama,
    perú: flagPeru,
    "republica-dominicana": flagRepublicaDominicana,
  };

  const updateOptions = (
    key: keyof IOptionsMetricsRanking,
    value: SelectOption[]
  ) => {
    setOptionSelect((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const memoizedHandleValidate = useMemo(
    () => handleValidate,
    [handleValidate]
  );

  useEffect(() => {
    const hasAtLeastOneFalse = Object.values(memoizedHandleValidate).some(
      (value) => value === true
    );

    if (hasAtLeastOneFalse) {
      return setIsButtonValid(true);
    } else {
      return setIsButtonValid(false);
    }
  }, [memoizedHandleValidate]);

  useEffect(() => {
    getListTypeRanking(2);
    getCountryByUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSearchUser = (value: string) => {
    const filteredData = tableDataRef.current.filter((row) =>
      row.supervisor.toLowerCase().includes(value.toLowerCase())
    );

    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      tableFilteredData: filteredData,
      CurrentPage: 1,
    }));
  };

  const columnConfigMap: Record<string, TableColumns[]> = {
    GetRankingMetricByAdvisor: [
      { id: "position", label: t("header.position") },
      { id: "country", label: t("header.country") },
      { id: "advisor", label: t("header.advisor") },
      {
        id: "supervisor",
        label: t("header.supervisor"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={handleChangeSearchUser}
          />
        ),
      },
      { id: "compliance", label: t("header.compliance") },
    ],
    GetRankingMetricByPos: [
      { id: "position", label: t("header.position") },
      { id: "country", label: t("header.country") },
      { id: "pointOfSale", label: t("header.pointOfSale") },
      { id: "compliance", label: t("header.compliance") },
    ],
    GetRankingMetricByCountry: [
      { id: "position", label: t("header.position") },
      { id: "country", label: t("header.country") },
      { id: "finalCompliance", label: t("header.compliance") },
    ],
  };

  const getTableColumns = (name: string): TableColumns[] => {
    return columnConfigMap[name];
  };

  const pagedData = values.tableFilteredData.slice(
    (values.CurrentPage - 1) * values.PageSize,
    (values.CurrentPage - 1) * values.PageSize + values.PageSize
  );

  const handlePageChange = (page: number) => {
    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      CurrentPage: page,
    }));
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      PageSize: option.value,
    }));
  };

  const paginationProps: TablePagination = {
    currentPage: values.CurrentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize: values.PageSize,
    totalItems: values.TableData.length,
  };

  const handleOnDateChange = (newDate: any) => {
    const today = newDate;
    let startDate: Moment, endDate: Moment;

    if (values.TypeRanking[0] === "GetRankingByAdvisor") {
      setValues((prevState: IValuesMetricsRanking) => ({
        ...prevState,
        TableData: [],
        Columns: [],
      }));
      startDate = today.clone().startOf("isoWeek");
      endDate = today.clone().endOf("isoWeek");
    } else {
      setValues((prevState: IValuesMetricsRanking) => ({
        ...prevState,
        TableData: [],
        Columns: [],
      }));
      startDate = today.clone().startOf("month");
      endDate = today.clone().endOf("month");
    }

    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      Date: newDate,
      StartDate: startDate,
      EndDate: endDate,
    }));
    setHandleValidate((prevState: IValidationMetricsRanking) => ({
      ...prevState,
      Date: false,
    }));
    setForm((prevState: IFormMetricsRanking) => ({
      ...prevState,
      StartDate: String(startDate.format("YYYY-MM-DD")),
      EndDate: String(endDate.format("YYYY-MM-DD")),
    }));
  };

  const getListTypeRanking = (languageID: number) => {
    rankingMetricService
      .GetRankingMetricList(languageID)
      .then((result: IRankingMetricDtoDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.controllers,
          label: item.ranking,
        }));
        updateOptions("TypeRanking", updatedOptions);
        updateOptions("FilteredTypeRanking", updatedOptions);
      });
  };

  const getCountryByUser = () => {
    UsersManagementService.getCountriesList().then(
      (result: IGetCountriesListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.contryId,
          label: item.countryName,
        }));
        updateOptions("Country", updatedOptions);
        updateOptions("FilteredCountry", updatedOptions);
      }
    );
  };

  const onChangeTypeRanking = (
    selectedOption: SelectOption,
    setValues: React.Dispatch<React.SetStateAction<IValuesMetricsRanking>>,
    setHandleValidate: React.Dispatch<
      React.SetStateAction<IValidationMetricsRanking>
    >,
    setForm: React.Dispatch<React.SetStateAction<IFormMetricsRanking>>
  ) => {
    if (selectedOption.value === "GetRankingMetricByCountry") {
      setValues((prevState: IValuesMetricsRanking) => ({
        ...prevState,
        TypeRanking: [String(selectedOption.value)],
        Country: [],
        Date: undefined,
        StartDate: null,
        EndDate: null,
        TableData: [],
        Columns: [],
      }));
      setForm((prevState: IFormMetricsRanking) => ({
        ...prevState,
        Country: undefined,
        TypeRanking: String(selectedOption.value),
      }));
      setHandleValidate((prevState: IValidationMetricsRanking) => ({
        ...prevState,
        TypeRanking: false,
        Country: false,
        Date: true,
      }));
    } else {
      setValues((prevState: IValuesMetricsRanking) => ({
        ...prevState,
        TypeRanking: [String(selectedOption.value)],
        Country: [],
        Date: undefined,
        StartDate: null,
        EndDate: null,
        TableData: [],
        Columns: [],
      }));
      setForm((prevState: IFormMetricsRanking) => ({
        ...prevState,
        Country: 0,
        TypeRanking: String(selectedOption.value),
      }));
      setHandleValidate((prevState: IValidationMetricsRanking) => ({
        ...prevState,
        TypeRanking: false,
        Country: false,
        Date: true,
      }));
    }
  };

  const onChangeCountry = (
    selectedOption: SelectOption,
    setValues: React.Dispatch<React.SetStateAction<IValuesMetricsRanking>>,
    setHandleValidate: React.Dispatch<
      React.SetStateAction<IValidationMetricsRanking>
    >,
    setForm: React.Dispatch<React.SetStateAction<IFormMetricsRanking>>
  ) => {
    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      Country: [Number(selectedOption.value)],
    }));
    setForm((prevState: IFormMetricsRanking) => ({
      ...prevState,
      Country: Number(selectedOption.value),
    }));
    setHandleValidate((prevState: IValidationMetricsRanking) => ({
      ...prevState,
      Country: false,
    }));
  };

  function onClickObtainMetricsRanking(): void {
    const column = getTableColumns(values.TypeRanking[0]);

    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      Columns: column,
      CurrentPage: 1,
      TableData: [],
      Loading: true,
    }));

    rankingMetricService
      .GetRankingMetrics(form)
      .then((result: any[]) => {
        const updatedTableData = result.map((item: any) => {
          const row: Record<string, any> = {};
          column.forEach((col) => {
            row[col.id] = item[col.id] || "";
          });

          const countryKey = row.country.toLowerCase().replace(" ", "-");

          row.country = (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                className="colleaguesImagesCountries"
                src={flags[countryKey] || flagNotFound}
                alt={`${row.country} flag`}
              />
              <p style={{ marginLeft: "15px" }}>
              {row.country}
              </p>
            </div>
          );

          return {
            ...row,
            rowConfig: {
              disabled: false,
              noWrap: false,
              selected: false,
            },
          };
        });
        setValues((prevState: IValuesMetricsRanking) => {
          const updatedValues = {
            ...prevState,
            TableData: updatedTableData,
            tableFilteredData: updatedTableData,
            Loading: false,
          };
          tableDataRef.current = updatedTableData;
          return updatedValues;
        });
      })
      .catch(() => {
        console.error("Error fetching data");
        setValues((prevState: IValuesMetricsRanking) => ({
          ...prevState,
          Loading: false,
        }));
      });
  }
  
  const onClearCountry = () => {
    setValues((prevState: IValuesMetricsRanking) => ({
      ...prevState,
      Country: [],
    }));
    if (values.TypeRanking[0] !== "GetRankingMetricByCountry") {
      setForm((prevState: IFormMetricsRanking) => ({
        ...prevState,
        Country: 0,
      }));
    } else {
      setForm((prevState: IFormMetricsRanking) => ({
        ...prevState,
        Country: undefined,
      }));
    }
    
  }

    const isFutureDate = (day: MomentObj) => {
    return day.isAfter(moment(), "day");
  };

  return (
    <>
      <div style={{ padding: "1%" }}>
        <h4>{t("header.rankingMetrics")}</h4>
      </div>

      <div className="metricsRanking-container">
        <Select
          className="metricsRanking-select"
          clearIcon={false}
          options={optionSelect.TypeRanking}
          id="selectTypeRanking"
          label={t("header.typeOfRanking")}
          placement="bottom"
          helperTextVisibility="auto"
          onChange={(selectedOption: SelectOption) =>
            onChangeTypeRanking(
              selectedOption,
              setValues,
              setHandleValidate,
              setForm
            )
          }
          value={values.TypeRanking}
          required={handleValidate.TypeRanking}
          onSearch={(query: string) =>
            handleSearch(
              query,
              "TypeRanking",
              optionSelect.FilteredTypeRanking,
              setOptionSelect
            )
          }
          searchDelay={500}
          showSearch={true}
        />

        <Select
          className="metricsRanking-select"
          clearIcon={true}
          options={optionSelect.Country}
          id="selectCountry"
          label={t("header.country")}
          placement="bottom"
          helperTextVisibility="auto"
          onChange={(selectedOption: SelectOption) =>
            onChangeCountry(
              selectedOption,
              setValues,
              setHandleValidate,
              setForm
            )
          }
          value={values.Country}
          onClear={onClearCountry}
          onSearch={(query: string) =>
            handleSearch(
              query,
              "Country",
              optionSelect.FilteredCountry,
              setOptionSelect
            )
          }
          searchDelay={500}
          showSearch={true}
        />

        <DatePicker
          className="metricsRanking-datePicker"
          required={handleValidate.Date}
          clearIcon={false}
          label={t("header.date")}
          onChange={handleOnDateChange}
          orientation="horizontal"
          placeholder="MM/DD/YYYY"
          value={values.Date}
          disabled={values.TypeRanking.length === 0}
          isOutsideRange={isFutureDate}
        />

        <DatePicker
          className="metricsRanking-datePicker"
          endDate={values.EndDate ? values.EndDate.toISOString() : undefined}
          format="ll"
          clearIcon={false}
          range
          startDate={
            values.StartDate ? values.StartDate.toISOString() : undefined
          }
          startDateLabel={t("header.stardDate")}
          endDateLabel={t("header.endDate")}
          disabled={true}
        />

        <Button
          className="metricsRanking-button"
          disabled={isButtonValid}
          onClick={() => onClickObtainMetricsRanking()}
        >
          {t("header.calculateRanking")}
        </Button>
      </div>

      {values.Columns.length > 0 && (
        <div style={{ padding: "20px" }}>
          <Card
            appearance="outlined"
            className="divTableMetricsRanking"
            content={
              <Table
                showFilters={true}
                className="tableMetricsRanking"
                behavior={{
                  type: "singlePage",
                }}
                columnResize
                loading={values.Loading}
                columns={values.Columns}
                data={pagedData}
                loadingDataLength={5}
                pagination={paginationProps}
              />
            }
          />
        </div>
      )}
    </>
  );
}
